import GlobalState from "scripts/components/globalState"

// State machine based on globalState
export const modalInfoCenteredState = new GlobalState({
  isModalOpen: false,
  isLoading: true,
  phrases: {
    title: "",
    description: "",
    button: "",
  },
})